import React from 'react';

interface ResizeHandlesProps {
  isSelected: boolean;
  onResizeStart: (e: React.MouseEvent, direction: string) => void;
  handleOffset?: number; // Offset from edges, default -6px for outside, 0px for inside
}

export const ResizeHandles: React.FC<ResizeHandlesProps> = ({
  isSelected,
  onResizeStart,
  handleOffset = -6
}) => {
  if (!isSelected) return null;

  const handleStyle = (top?: number, right?: number, bottom?: number, left?: number, transform?: string) => ({
    top: top !== undefined ? `${top + handleOffset}px` : undefined,
    right: right !== undefined ? `${right + handleOffset}px` : undefined,
    bottom: bottom !== undefined ? `${bottom + handleOffset}px` : undefined,
    left: left !== undefined ? `${left + handleOffset}px` : undefined,
    transform
  });

  return (
    <>
      {/* Corner handles */}
      <div
        className="resize-handle cursor-nw-resize"
        style={handleStyle(0, undefined, undefined, 0)}
        onMouseDown={(e) => onResizeStart(e, 'nw')}
      />
      <div
        className="resize-handle cursor-ne-resize"
        style={handleStyle(0, 0, undefined, undefined)}
        onMouseDown={(e) => onResizeStart(e, 'ne')}
      />
      <div
        className="resize-handle cursor-sw-resize"
        style={handleStyle(undefined, undefined, 0, 0)}
        onMouseDown={(e) => onResizeStart(e, 'sw')}
      />
      <div
        className="resize-handle cursor-se-resize"
        style={handleStyle(undefined, 0, 0, undefined)}
        onMouseDown={(e) => onResizeStart(e, 'se')}
      />

      {/* Edge handles */}
      <div
        className="resize-handle cursor-n-resize"
        style={{
          top: `${handleOffset}px`,
          left: '50%',
          transform: 'translateX(-50%)'
        }}
        onMouseDown={(e) => onResizeStart(e, 'n')}
      />
      <div
        className="resize-handle cursor-s-resize"
        style={{
          bottom: `${handleOffset}px`,
          left: '50%',
          transform: 'translateX(-50%)'
        }}
        onMouseDown={(e) => onResizeStart(e, 's')}
      />
      <div
        className="resize-handle cursor-w-resize"
        style={{
          left: `${handleOffset}px`,
          top: '50%',
          transform: 'translateY(-50%)'
        }}
        onMouseDown={(e) => onResizeStart(e, 'w')}
      />
      <div
        className="resize-handle cursor-e-resize"
        style={{
          right: `${handleOffset}px`,
          top: '50%',
          transform: 'translateY(-50%)'
        }}
        onMouseDown={(e) => onResizeStart(e, 'e')}
      />
    </>
  );
};
